import { Charts } from './Charts';
import EstablishmentLocationChartsDataProvider from './contexts/EstablishmentLocationChartsDataContext';

const EstablishmentLocationWrapper = () => {
    return (
        <EstablishmentLocationChartsDataProvider>
            <Charts />
        </EstablishmentLocationChartsDataProvider>
    );
};

export default EstablishmentLocationWrapper;